var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.profile)?_c('span',{staticClass:"navbar-text"},[_c('b',[_vm._v(_vm._s(_vm.profile.name)+" ")]),_vm._v(" "),_c('span',{staticClass:"d-sm-none d-xl-inline"},[_vm._v(" ("+_vm._s(_vm.profile.roleName)+")")]),_vm._v(" "),_c('br'),_vm._v(" "+_vm._s(_vm.profile.companyName)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }